import { useQuery } from '@apollo/client';
import {
    CITRIN_GET_TRIPS_SUMMARY_BY_PASSENGER_ID,
    GetTripsSummaryByPassengerIdResponse,
    GetTripsSummaryByPassengerIdRequest,
} from '..';
import { TripsRiderFilter } from '../../shared/types';

export const useGetTripsSummaryByPassengerIdQuery = (request: TripsRiderFilter) => {
    const { data, previousData, ...rest } = useQuery<
        GetTripsSummaryByPassengerIdResponse,
        GetTripsSummaryByPassengerIdRequest
    >(CITRIN_GET_TRIPS_SUMMARY_BY_PASSENGER_ID, {
        variables: { request },
        skip: !request.id || !request.startDate || !request.endDate,
        //fetchPolicy: 'cache-and-network',
        //onCompleted: (data) => console.log('[MGT] Riders', data),
    });
    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getTripsSummaryByPassengerId,
        data: data?.CITRIN_MGT_getTripsSummaryByPassengerId,
    };
};
